export default __webpack_public_path__ + "static/media/colormap-demo.cec11151.jpg";